import { defineMessages } from "react-intl";

const messages = defineMessages({
  error: {
    id: "fileStorage.components.unauthorized.error",
    defaultMessage: "User does not have permission to access this file.",
  },
});

export default messages;
